import { createAction } from "@reduxjs/toolkit";

export const RE_INITIALIZE_STORE = createAction("RE_INITIALIZE_STORE");
